<div class="timezone">{{'voting.voted_date_timezone' | translate: ({timezone: currentTimezone})}}</div>
